import React from 'react';
import { DownloadOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import { exportRecordsToCsv } from '@totem/utilities/fileUtilities';

type Props = {
  fileName: string;
  headers: string[];
  rows: (string | number)[][];
};

// Builds the CSV client-side from data already loaded into the table (no
// server round-trip) and downloads it.
const IBTableExportButton = ({ fileName, headers, rows }: Props) => (
  <Button
    type="default"
    size="small"
    icon={<DownloadOutlined />}
    onClick={() => exportRecordsToCsv(fileName, headers, rows)}
  >
    Export
  </Button>
);

export default IBTableExportButton;
